export default __webpack_public_path__ + "static/media/marker-blue.9ada0c9c.png";